export const globals: ReturnsCentreGlobals = window.RETURNS_CENTRE_GLOBALS;

